<template>
  <!-- A header that sticks to the top of the page -->
  <sticky-header v-model:title="title[lang]" v-model:lang="lang" v-model:hideMenu="hideMenu"></sticky-header>
  <!-- Page main content -->
  <main id="page-content" class="flex-shrink-0">
    <!-- Navigation menu on the left -->
    <div id="left-side">
      <left-menu v-model:links="menuLinks" v-model:lang="lang" v-model:hideMenu="hideMenu"></left-menu>
    </div>
    <!-- Content of the page -->
    <div id="right-side" v-on:click="hideLeftMenuState()">
      <page-object v-model:selectedLang="lang"></page-object>
    </div>
  </main>
  <!-- A footer that sticks to the bottom of the page -->
  <sticky-footer></sticky-footer>
</template>

<script>
import StickyHeader from './components/StickyHeader.vue'
import LeftMenu from './components/LeftMenu.vue'
import PageObject from './components/PageObject.vue'
import StickyFooter from './components/SitckyFooter.vue'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default {
  name: 'App',
  components: {
    StickyHeader,
    LeftMenu,
    PageObject,
    StickyFooter
  },
  data(){ 
    return {
      // Items for the navigation menu
      menuLinks : [
      {
        // Name of the item in different language
        'name' : {
         'fr' : 'Terminologie Universitaire',
         'en' : 'University Terminology',
         'nl' : 'Universitaire Terminologie' 
        },
        // A name that doesn't change, used as identifier
        'canonical' : 'UnivTermino'
      },
      {
        'name' : {
         'fr' : 'Aide à la traduction',
         'en' : 'Translation Assistant',
         'nl' : 'Vertallhulp' 
        },
        'canonical' : 'TranslationAssistant'
      },
      {
        'name' : {
         'fr' : 'Explorer le web',
         'en' : 'Web Explorer',
         'nl' : 'Doorzoek het web' 
        },
        'canonical' : 'WebExplorer'
      },
      {
        'name' : {
         'fr' : 'Dictionnaires',
         'en' : 'Dictionaries',
         'nl' : 'Woordenboeken' 
        },
        'canonical' : 'Dictionaries'
      },
      {
        'name' : {
         'fr' : 'Suggestions',
         'en' : 'Suggestions',
         'nl' : 'Suggesties' 
        },
        'canonical' : 'Suggestions'
      },
      // {
      //   'name' : {
      //    'fr' : 'A propos',
      //    'en' : 'About',
      //    'nl' : 'Over ons' 
      //   },
      //   'canonical' : 'About'
      // }
      ],
      // Tells if the side menu must be visible or not
      hideMenu : true,
      // Main title of the page
      title : {
        'en': 'UCL-K.U.Leuven University Terminology Database',
        'fr' : 'Base de données de terminologie universitaire UCL-K.U.Leuven',
        'nl' : 'Database universitaire terminologie K.U.Leuven-UCL'
      },
      // Selected language
      lang : 'en'
    } 
  },
  methods: {
    // Function called by children to change the selected
    // item in the navigation bar
    updateSelectedItem(item){
      this.selectedMenuItem = item;
    },
    // Function called by children to change the selected
    // language
    changeLang(newLang){
      this.lang = newLang;
    },
    // Function called by children to show/hide LeftMenu
    changeLeftMenuState(){
      this.hideMenu = !this.hideMenu;
    },
    // Function called by children to hide LeftMenu
    hideLeftMenuState(){
      this.hideMenu = true;
    }
  },
  // On load function
  created : function () {
    let browserLang = navigator.language;
    // Remove region indication (ex : from 'en-US' extract 'en')
    if (browserLang.includes("-")) {
      browserLang = browserLang.split("-")[0];
    }
    // Set english as default when browser language is not supported
    if (browserLang != "fr" && browserLang != "nl") {
      browserLang = "en"
    }
    // Set language
    this.lang = browserLang;
  }
}
</script>

<style>
* {
  margin : 0px;
  padding : 0px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width : 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#right-side {
  width: 100%;
  height: 100%;
  margin-right : 0;
  margin-left : auto;
  margin-top: auto;
}

#page-content {
  width: 100%;
  height: auto;
  margin-top: 8vh;
  display: flex;
}

/* Remove default margins */
body, html {
  height: 100%;
  width: 100%;
  font-size: 16px;
}


/* Header display for pageObjects with a help button */

#objectTitleContainer {
  display : flex;
}

#objectTitleSizer {
  width: 90%;
  text-align: center;
}

#helpButtonSizer{
  width: 5%;
  color :#00214e;
  cursor: pointer;
}

#helpButtonSizer svg{
  width: 100%;
  height: 50%;
}

/* Display bootstrap buttons with the right collor */

.btn {
  background-color: #00214e;
  border : 1px solid #00214e;
}
</style>
